import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import user from "./modules/user";
import withholdUser from "./modules/withholdUser";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    withholdUser,
  },
  getters,
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js